/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Formulario from '../../components/public/Formulario/Formulario';
import {
  IEmail,
  IFormAlquiler,
  IFormato,
  IFormDatosContactoExt,
  IFormulario,
  ISelectOptions,
} from '../../utils/models/interfaces';
import PageContainer from 'components/PageContainer/PageContainer';
import { datosFormAlquiler, datosFormContactoExt, datosFormDatosPersonales, tooltips } from 'utils/formData';
import { crearOpcionesTipos } from 'utils/utilities';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { fetchSalas } from 'utils/redux/features/salasSlice';
import { useError } from 'services/ErrorContext';
import Spinner from 'components/public/Spinner/Spinner';
import { alturaContainer, anchoMaxFormContacto } from 'utils/constants';
import { solicitudFormularios } from 'services/servicioPost';
import { DomainAddOutlined } from '@mui/icons-material';
import { Box, styled, Typography } from '@mui/material';
import NoResponse from 'pages/auxiliares/NoResponse';
import { fetchSalaPorId } from 'utils/redux/features/salaIdSlice';
import SalaTeatro from 'assets/fotosSalas/SalaTeatro.jpeg';
import { textoSalas } from '../../utils/constants';
import { TextoSala } from '../../utils/models/interfaces';

const BoxSala = styled(Box)`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  padding: 16px 8px;
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  margin: 16px 0;
`;

const Alquiler = () => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { salas, loadingSalas, errorSalas } = useSelector((state: RootState) => state.salas);
  const { error, setError, clearError, loading, setLoading } = useError();
  const dispatch = useDispatch<AppDispatch>();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);

  useEffect(() => {
    dispatch(fetchSalas());
    clearError();
  }, [dispatch]);

  const datosNombreApellido = datosFormDatosPersonales.filter(
    dato => dato.name === 'nombre' || dato.name === 'apellido'
  );

  const datosFormContactoLogueado: IFormato<IFormDatosContactoExt>[] = [
    {
      name: 'Telefono',
      label: 'Teléfono',
      inputType: 'tel',
      halfWidth: 'left',
      pattern: tooltips.telefono.pattern,
      tooltip: tooltips.telefono.tooltip,
      adornment: 'tel',
      defaultValue: usuario?.Telefono,
      subtituloSeccion: 'Ingresá los datos para que podamos contactarnos contigo',
    },
    {
      name: 'Email',
      label: 'Email',
      required: false,
      inputType: 'email',
      adornment: 'email',
      pattern: tooltips.email.pattern,
      tooltip: tooltips.email.tooltip,
      halfWidth: 'right',
      defaultValue: usuario?.Email,
    },
  ];

  const camposAlquiler: IFormato<IFormAlquiler>[] = usuario
    ? [...datosFormContactoLogueado, ...datosFormAlquiler]
    : [...datosNombreApellido, ...datosFormContactoExt, ...datosFormAlquiler];

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const nombre = data.nombre || usuario?.Nombre;
    const apellido = data.apellido || usuario?.Apellido;
    const email = data.Email || usuario?.Emai;
    const telefono = data.Telefono || usuario?.Telefono;
    const sala = await dispatch(fetchSalaPorId(Number(data.Sala)));

    // @ts-expect-error -- thunk payload shape not typed
    const nombreSala = sala?.payload?.Nombre;
    const request: IEmail = {
      Subject: 'Teatro Bosch Web - Nueva solicitud de alquiler de sala',
      Body: `
      Nombre: ${nombre} <br>
      Apellido: ${apellido}<br>
      Email: ${email ? email : 'No ingresado'} <br>
      Teléfono: ${telefono}<br>
      Motivo de consulta: <br>
      ${data.motivoConsulta}
      `,
      Title: `Sala de interés: ${nombreSala}`,
    };

    try {
      if (!nombre || !apellido || !telefono || !nombreSala) {
        setError('Error en alguno de los datos');
        throw new Error('Error en alguno de los datos');
      }
      await solicitudFormularios('alquiler', request, setError, setLoading);
      setMensajeExito('¡Gracias por tu solicitud de alquiler! Nos pondremos en contacto contigo.');
    } catch (err) {
    }
  }

  const opcionesSalas: ISelectOptions[] = crearOpcionesTipos(salas, 'Sala');

  const handleVolver = () => {
    setMensajeExito('');
  };

  const alturaFotosSalasSuperiores = { xs: '100%', md: '280px!important' };
  const anchoTextoIntro = 700;
  const anchoMax = 1000;

  return (
    <PageContainer marginBottom={true}>
      {loadingSalas ? (
        <Spinner />
      ) : (
        <Box minHeight={alturaContainer} width={anchoMaxFormContacto} maxWidth={anchoMax} mx="auto">
          {errorSalas ? (
            <NoResponse />
          ) : (
            <>
              {!mensajeExito && (
                <Box textAlign="left" width={anchoMaxFormContacto} maxWidth={anchoMax}>
                  <Typography variant="h3" fontSize={{ xs: '30px', sm: '40px' }} pb={3}>
                    Salas Espacio H. Bosch
                  </Typography>
                  <Typography maxWidth={anchoTextoIntro}>
                    La casona de <b>Espacio H. Bosch</b> cuenta con una Sala Teatral con 66 butacas, a nivel de calle,
                    adaptable a distintos formatos.
                  </Typography>
                  <Typography pt={2} maxWidth={anchoTextoIntro}>
                    Así también, cuenta con 3 salas más pequeñas en la primer planta, aptas para ensayos, eventos,
                    clases, charlas, o puestas en escena alternativas.
                  </Typography>
                  <Typography variant="h5" lineHeight={3}>
                    Sala Teatro
                  </Typography>
                  <Typography>Dimensiones: 16,00 x 7,00 mts.</Typography>
                  <Typography pb={1}>Capacidad: 66 butacas. Cuenta con luces y consola.</Typography>
                  <Box
                    component="img"
                    src={SalaTeatro}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  <Typography variant="h5" mt={3}>
                    Salas superiores
                  </Typography>
                  {textoSalas.map(({ nombre, descripcion1, descripcion2, foto }: TextoSala) => (
                    <BoxSala key={nombre} sx={{ display: { xs: 'block', md: 'flex' } }}>
                      <Box flex="1" ml={{ xs: 'unset', md: 2 }}>
                        <Typography variant="h6" fontWeight={600} pb={3}>
                          {nombre}
                        </Typography>
                        <Typography>{descripcion1}</Typography>
                        {descripcion2 && <Typography>{descripcion2}</Typography>}
                      </Box>
                      <Box
                        component="img"
                        src={foto}
                        sx={{
                          mt: { xs: 2, md: 'unset' },
                          width: alturaFotosSalasSuperiores,
                          height: alturaFotosSalasSuperiores,
                          objectFit: 'cover',
                        }}
                      />
                    </BoxSala>
                  ))}
                </Box>
              )}

              <Formulario
                campos={camposAlquiler}
                anchoMax={1000}
                titulo="Alquiler de sala"
                mensaje="Consulta de alquiler"
                datos={opcionesSalas}
                onSubmit={handleSubmit}
                onVolver={handleVolver}
                mensajeExito={mensajeExito}
                mensajeError={error}
                loading={loading}
                iconoBoton={DomainAddOutlined}
              />
            </>
          )}
        </Box>
      )}
    </PageContainer>
  );
};

export default Alquiler;
